module.exports = __webpack_public_path__ + "static/media/projectPic6.f950d8e3.png";